export default "__VITE_ASSET__D75Uo3vA__"